module.exports = __webpack_public_path__ + "static/media/junipertree.9e1b047e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/junipertree.png
// module id = 370
// module chunks = 0